import Utils from '../../services/Utils'
import { GApi, defineCancelApiObject, defaultHeaders } from '../config/GApi'
import { FormErrorStrategy } from '../config/ErrorHandler'

const EmbeddedApi = {
  get: async function (reportId, viewAsUserId = null, cancel = false) {
    let url = '/global-reporting/embedded/' + reportId
    if (viewAsUserId) {
      url += '?viewAsUserId=' + viewAsUserId
    }

    const response = await GApi.request({
      url: url,
      method: 'GET',
      headers: defaultHeaders(),
      errorStrategy: FormErrorStrategy,
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    })

    Utils.ensureJson(response)

    return response.data
  },
}

// defining the cancel API object for ProductAPI
const cancelApiObject = defineCancelApiObject(EmbeddedApi)

export default EmbeddedApi
